<template>
  <div>
    <h3 class="main-title"><b>{{ $t("main-title") }}</b></h3>
    <h3 class="main-title"><b>{{ $t("main-title2") }}</b></h3>

    <b-container class="pia-content px-5">
      <h4 class="mt-5">
        <b>{{ $t("sub-title1") }}</b>
      </h4>
      <br />
      <div>{{ $t("sub-title1-paragraph1") }}</div>
      <br />
      <div>{{ $t("sub-title1-paragraph2") }}</div>
      <br />
      <div>{{ $t("sub-title1-paragraph3") }}</div>
      <h4 class="mt-5">
        <b>{{ $t("sub-title2") }}</b>
      </h4>
      <br />
      <h5>
        <b>{{ $t("sub-title2-titleA") }}</b>
      </h5>
      <br />
      <div>{{ $t("sub-title2-titleA-paragraph1") }}</div>
      <br />
      <div>{{ $t("sub-title2-titleA-paragraph2") }}</div>
      <br />
      <div>{{ $t("sub-title2-titleA-paragraph3") }}</div>
      <br />
      <div>{{ $t("sub-title2-titleA-paragraph4") }}</div>
      <br />
      <h5>
        <b>{{ $t("sub-title2-titleB") }}</b>
      </h5>
      <br />
      <h6>{{ $t("sub-title2-titleB-subtitle1") }}</h6>
      <br />
      <div>{{ $t("sub-title2-titleB-subtitle1-paragraph1") }}</div>
      <br />
      <div>{{ $t("sub-title2-titleB-subtitle1-paragraph2") }}</div>
      <br />
      <h6>{{ $t("sub-title2-titleB-subtitle2") }}</h6>
      <br />
      <div>{{ $t("sub-title2-titleB-subtitle2-paragraph1") }}</div>
      <br />
      <ol type="a">
        <li>{{ $t("sub-title2-titleB-subtitle2-paragraph1-a") }}</li>
        <li class="mt-2">{{ $t("sub-title2-titleB-subtitle2-paragraph1-b") }}</li>
        <li class="mt-2">{{ $t("sub-title2-titleB-subtitle2-paragraph1-c") }}</li>
        <li class="mt-2">{{ $t("sub-title2-titleB-subtitle2-paragraph1-d") }}</li>
        <li class="mt-2">{{ $t("sub-title2-titleB-subtitle2-paragraph1-e") }}</li>
        <li class="mt-2">{{ $t("sub-title2-titleB-subtitle2-paragraph1-f") }}</li>
      </ol>
      <h6>{{ $t("sub-title2-titleB-subtitle3") }}</h6>
      <br />
      <div>
        <a>{{ $t("sub-title2-titleB-subtitle3-paragraph1-1") }}</a>
        <a style="font-size:10px;vertical-align:top;">1</a>
        {{ $t("sub-title2-titleB-subtitle3-paragraph1-2") }}
      </div>
      <br />
      <ol type="a">
        <li>{{ $t("sub-title2-titleB-subtitle3-paragraph1-a") }}</li>
        <li class="mt-2">{{ $t("sub-title2-titleB-subtitle3-paragraph1-b") }}</li>
      </ol>
      <br />
      <h5>
        <b>{{ $t("sub-title2-titleC") }}</b>
      </h5>
      <br />
      <div>{{ $t("sub-title2-titleC-paragraph1") }}</div>
      <br />
      <h5>
        <b>{{ $t("sub-title2-titleD") }}</b>
      </h5>
      <br />
      <div>{{ $t("sub-title2-titleD-paragraph1") }}</div>
      <br />
      <h5>
        <b>{{ $t("sub-title2-titleE") }}</b>
      </h5>
      <br />
      <div>{{ $t("sub-title2-titleE-paragraph1") }}</div>
      <br />
      <h5>
        <b>{{ $t("sub-title2-titleF") }}</b>
      </h5>
      <br />
      <div>{{ $t("sub-title2-titleF-paragraph1") }}</div>
      <br />
      <div>{{ $t("sub-title2-titleF-paragraph2") }}</div>
      <br />
      <h5>
        <b>{{ $t("sub-title2-titleG") }}</b>
      </h5>
      <br />
      <div>{{ $t("sub-title2-titleG-paragraph1") }}</div>
      <br />
      <div>{{ $t("sub-title2-titleG-paragraph2") }}</div>
      <br />
      <div>{{ $t("sub-title2-titleG-paragraph3") }}</div>
      <br />
      <div class="float-right">{{$t('last-revision-date')}}</div>
      <br />
      <div class="mt-4">
        <div class="sub-title pb-5" style="font-size:10px; border-top:1px solid black;">
          <div>1</div>
          <div class="ml-2 paragraph">{{ $t("notice") }}</div>
        </div>
      </div>
    </b-container>
  </div>
</template>

<style lang="scss" scoped>
.main-title {
  display: flex;
  justify-content: center;
  text-align: center;
}
.bd-blue:hover {
 text-decoration: underline;
}
.sub-title {
  display: flex;
}
</style>

<script>
export default {
  methods: {
    redirectLogin() {
      this.$router.push({ name: 'Login' });
    },
  }
};
</script>

<i18n src="@/locales/actions.locale"></i18n>

<i18n src="@/public/locales/modules/pia/components/PrivacyPolicyStatement.json" />